import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
};

export const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    getServices: (state) => {
      state.loading = true;
    },
    successService: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    failedService: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  },
});

export const { getServices, successService, failedService } = serviceSlice.actions;

export default serviceSlice.reducer;
